import ReferralsList from 'components/common/ReferralsList'
import DetailsSection from '../common/DetailsSection'
import DetailsValue from '../common/DetailsValue'
import { observer } from 'mobx-react-lite'
import { ReactNode } from 'react'

type ReferralsSectionProps = {
  // TODO: improve visit type
  visit: any
}

const ReferralsSection = ({ visit }: ReferralsSectionProps) => {
  const { isSuccess, referral } = visit || {}

  if (referral?.empty) {
    return null
  }

  return (
    <DetailsSection title={`${isSuccess ? 'Student' : 'Patient'} referrals`}>
      <div className="grid grid-cols-1 sm:grid-cols-4 gap-x-6 gap-y-4">
        <ReferralsList
          visit={visit}
          renderItem={({ label, value }: { label: string; value: ReactNode }) => (
            <DetailsValue label={label} value={value} emptyValue="-" />
          )}
        />
      </div>
    </DetailsSection>
  )
}

export default observer(ReferralsSection)
